module.exports = __webpack_public_path__ + "img/pageLogo.e49cfb29.png";